/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { boothApplicationControllerCreateV1 } from '../fn/booth-application/booth-application-controller-create-v-1';
import { BoothApplicationControllerCreateV1$Params } from '../fn/booth-application/booth-application-controller-create-v-1';
import { boothApplicationControllerDeleteV1 } from '../fn/booth-application/booth-application-controller-delete-v-1';
import { BoothApplicationControllerDeleteV1$Params } from '../fn/booth-application/booth-application-controller-delete-v-1';
import { boothApplicationControllerFindAllV1 } from '../fn/booth-application/booth-application-controller-find-all-v-1';
import { BoothApplicationControllerFindAllV1$Params } from '../fn/booth-application/booth-application-controller-find-all-v-1';
import { boothApplicationControllerFindByIdV1 } from '../fn/booth-application/booth-application-controller-find-by-id-v-1';
import { BoothApplicationControllerFindByIdV1$Params } from '../fn/booth-application/booth-application-controller-find-by-id-v-1';
import { boothApplicationControllerGetAvailableTemplatesV1 } from '../fn/booth-application/booth-application-controller-get-available-templates-v-1';
import { BoothApplicationControllerGetAvailableTemplatesV1$Params } from '../fn/booth-application/booth-application-controller-get-available-templates-v-1';
import { boothApplicationControllerSearchCursorV1 } from '../fn/booth-application/booth-application-controller-search-cursor-v-1';
import { BoothApplicationControllerSearchCursorV1$Params } from '../fn/booth-application/booth-application-controller-search-cursor-v-1';
import { boothApplicationControllerSearchV1 } from '../fn/booth-application/booth-application-controller-search-v-1';
import { BoothApplicationControllerSearchV1$Params } from '../fn/booth-application/booth-application-controller-search-v-1';
import { boothApplicationControllerUpdateV1 } from '../fn/booth-application/booth-application-controller-update-v-1';
import { BoothApplicationControllerUpdateV1$Params } from '../fn/booth-application/booth-application-controller-update-v-1';
import { BoothApplicationDto } from '../models/booth-application-dto';
import { BoothOptionTemplateDto } from '../models/booth-option-template-dto';
import { CursorPaginationDto } from '../models/cursor-pagination-dto';
import { OffsetPaginationDto } from '../models/offset-pagination-dto';

@Injectable({ providedIn: 'root' })
export class BoothApplicationService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `boothApplicationControllerSearchV1()` */
  static readonly BoothApplicationControllerSearchV1Path = '/api/v1/booth-application/search';

  /**
   * 부스 신청 검색.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `boothApplicationControllerSearchV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  boothApplicationControllerSearchV1$Response(params?: BoothApplicationControllerSearchV1$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto & {
'items'?: Array<BoothApplicationDto>;
}>> {
    return boothApplicationControllerSearchV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 부스 신청 검색.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `boothApplicationControllerSearchV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  boothApplicationControllerSearchV1(params?: BoothApplicationControllerSearchV1$Params, context?: HttpContext): Observable<OffsetPaginationDto & {
'items'?: Array<BoothApplicationDto>;
}> {
    return this.boothApplicationControllerSearchV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<OffsetPaginationDto & {
'items'?: Array<BoothApplicationDto>;
}>): OffsetPaginationDto & {
'items'?: Array<BoothApplicationDto>;
} => r.body)
    );
  }

  /** Path part for operation `boothApplicationControllerSearchCursorV1()` */
  static readonly BoothApplicationControllerSearchCursorV1Path = '/api/v1/booth-application/search/cursor';

  /**
   * 부스 신청 커서 기반 검색.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `boothApplicationControllerSearchCursorV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  boothApplicationControllerSearchCursorV1$Response(params?: BoothApplicationControllerSearchCursorV1$Params, context?: HttpContext): Observable<StrictHttpResponse<CursorPaginationDto & {
'items'?: Array<BoothApplicationDto>;
}>> {
    return boothApplicationControllerSearchCursorV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 부스 신청 커서 기반 검색.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `boothApplicationControllerSearchCursorV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  boothApplicationControllerSearchCursorV1(params?: BoothApplicationControllerSearchCursorV1$Params, context?: HttpContext): Observable<CursorPaginationDto & {
'items'?: Array<BoothApplicationDto>;
}> {
    return this.boothApplicationControllerSearchCursorV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<CursorPaginationDto & {
'items'?: Array<BoothApplicationDto>;
}>): CursorPaginationDto & {
'items'?: Array<BoothApplicationDto>;
} => r.body)
    );
  }

  /** Path part for operation `boothApplicationControllerGetAvailableTemplatesV1()` */
  static readonly BoothApplicationControllerGetAvailableTemplatesV1Path = '/api/v1/booth-application/templates/{eventId}';

  /**
   * 행사별 사용 가능한 부스 옵션 템플릿 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `boothApplicationControllerGetAvailableTemplatesV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  boothApplicationControllerGetAvailableTemplatesV1$Response(params: BoothApplicationControllerGetAvailableTemplatesV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BoothOptionTemplateDto>>> {
    return boothApplicationControllerGetAvailableTemplatesV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 행사별 사용 가능한 부스 옵션 템플릿 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `boothApplicationControllerGetAvailableTemplatesV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  boothApplicationControllerGetAvailableTemplatesV1(params: BoothApplicationControllerGetAvailableTemplatesV1$Params, context?: HttpContext): Observable<Array<BoothOptionTemplateDto>> {
    return this.boothApplicationControllerGetAvailableTemplatesV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<BoothOptionTemplateDto>>): Array<BoothOptionTemplateDto> => r.body)
    );
  }

  /** Path part for operation `boothApplicationControllerFindAllV1()` */
  static readonly BoothApplicationControllerFindAllV1Path = '/api/v1/booth-application';

  /**
   * 모든 부스 신청 목록 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `boothApplicationControllerFindAllV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  boothApplicationControllerFindAllV1$Response(params?: BoothApplicationControllerFindAllV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BoothApplicationDto>>> {
    return boothApplicationControllerFindAllV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 모든 부스 신청 목록 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `boothApplicationControllerFindAllV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  boothApplicationControllerFindAllV1(params?: BoothApplicationControllerFindAllV1$Params, context?: HttpContext): Observable<Array<BoothApplicationDto>> {
    return this.boothApplicationControllerFindAllV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<BoothApplicationDto>>): Array<BoothApplicationDto> => r.body)
    );
  }

  /** Path part for operation `boothApplicationControllerCreateV1()` */
  static readonly BoothApplicationControllerCreateV1Path = '/api/v1/booth-application';

  /**
   * 부스 신청 생성 (비회원 사용자용).
   *
   * 사용자 페이지에서 비회원이 부스 신청을 생성합니다. companyId(기존 업체 선택) 또는 companyData(신규 업체 등록) 중 하나를 필수로 입력해야 합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `boothApplicationControllerCreateV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  boothApplicationControllerCreateV1$Response(params: BoothApplicationControllerCreateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<BoothApplicationDto>> {
    return boothApplicationControllerCreateV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 부스 신청 생성 (비회원 사용자용).
   *
   * 사용자 페이지에서 비회원이 부스 신청을 생성합니다. companyId(기존 업체 선택) 또는 companyData(신규 업체 등록) 중 하나를 필수로 입력해야 합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `boothApplicationControllerCreateV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  boothApplicationControllerCreateV1(params: BoothApplicationControllerCreateV1$Params, context?: HttpContext): Observable<BoothApplicationDto> {
    return this.boothApplicationControllerCreateV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<BoothApplicationDto>): BoothApplicationDto => r.body)
    );
  }

  /** Path part for operation `boothApplicationControllerFindByIdV1()` */
  static readonly BoothApplicationControllerFindByIdV1Path = '/api/v1/booth-application/{id}';

  /**
   * 부스 신청 id로 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `boothApplicationControllerFindByIdV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  boothApplicationControllerFindByIdV1$Response(params: BoothApplicationControllerFindByIdV1$Params, context?: HttpContext): Observable<StrictHttpResponse<BoothApplicationDto>> {
    return boothApplicationControllerFindByIdV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 부스 신청 id로 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `boothApplicationControllerFindByIdV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  boothApplicationControllerFindByIdV1(params: BoothApplicationControllerFindByIdV1$Params, context?: HttpContext): Observable<BoothApplicationDto> {
    return this.boothApplicationControllerFindByIdV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<BoothApplicationDto>): BoothApplicationDto => r.body)
    );
  }

  /** Path part for operation `boothApplicationControllerDeleteV1()` */
  static readonly BoothApplicationControllerDeleteV1Path = '/api/v1/booth-application/{id}';

  /**
   * 부스 신청 삭제 (관리자용).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `boothApplicationControllerDeleteV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  boothApplicationControllerDeleteV1$Response(params: BoothApplicationControllerDeleteV1$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return boothApplicationControllerDeleteV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 부스 신청 삭제 (관리자용).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `boothApplicationControllerDeleteV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  boothApplicationControllerDeleteV1(params: BoothApplicationControllerDeleteV1$Params, context?: HttpContext): Observable<boolean> {
    return this.boothApplicationControllerDeleteV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `boothApplicationControllerUpdateV1()` */
  static readonly BoothApplicationControllerUpdateV1Path = '/api/v1/booth-application/{id}';

  /**
   * 부스 신청 수정 (관리자용).
   *
   * 관리자가 부스 신청의 상태, 메모 등을 수정합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `boothApplicationControllerUpdateV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  boothApplicationControllerUpdateV1$Response(params: BoothApplicationControllerUpdateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<BoothApplicationDto>> {
    return boothApplicationControllerUpdateV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 부스 신청 수정 (관리자용).
   *
   * 관리자가 부스 신청의 상태, 메모 등을 수정합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `boothApplicationControllerUpdateV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  boothApplicationControllerUpdateV1(params: BoothApplicationControllerUpdateV1$Params, context?: HttpContext): Observable<BoothApplicationDto> {
    return this.boothApplicationControllerUpdateV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<BoothApplicationDto>): BoothApplicationDto => r.body)
    );
  }

}
